import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import Labels from '../../../../shared/Labels';
import { calculateCategoryLink } from '../../../../shared/helpers';
import { NestedCategory } from '../../../../../../shared/types';
import { ABSOLUTE_ROOT_PATH } from '../../../../../constants';

import './index.scss';

interface ArticleHeaderProps {
  title: string;
  description: string;
  publishedDate: string;
  dateModified?: string;
  category: NestedCategory;
  timeToRead?: number;
  author: {
    authorName: string;
  };
}

export const ArticleHeader = ({
  title,
  description,
  publishedDate,
  dateModified,
  category,
  timeToRead,
  author,
}: ArticleHeaderProps) => (
  <header>
    <div className="breadcrumbs">
      <a href={ABSOLUTE_ROOT_PATH}>
        <I18n k="fiverr_guides.breadcrumb.fiverr_domain" />
      </a>{' '}
      &gt; <a href={calculateCategoryLink(category)}>{category.title}</a>
    </div>
    <h1>{title}</h1>
    <p className="slogan">{description}</p>
    <Labels publishedDate={publishedDate} dateModified={dateModified} timeToRead={timeToRead} author={author} />
  </header>
);
